import React, { Component } from 'react';
import styled from 'styled-components';
import TalentsList from '../../teamData/teamOurTalents';
import mediaWidth, { Width } from '../../utils/mediaWidth/mediaWidth';
import ImageWithCaption, {
    WidthDesktop,
    WidthMobile,
    WidthTablet,
    WidthXDesktop,
} from '../../common/ImageWithCaption';
import CircleButtonWithArrow from '../../common/CircleButtonWithArrow';

const SlideWidthMobile = WidthMobile;
const SlideWidthTablet = WidthTablet;
const SlideWidthDesktop = WidthDesktop;
const SlideWidthXDesktop = WidthXDesktop;

const SlideMobileMarginRight = 16;
const SlideTabletMarginRight = 32;
const SlideDesktopMarginRight = 25;
const SlideXDesktopMarginRight = 32;

const scrollDirections = {
    right: 'right',
    left: 'left',
};

const getOffsetLeftWidth = (size, otherValue = 0) => (
    window.innerWidth > size
        ? ((window.innerWidth - size) / 2 + 14 + otherValue)
        : ((window.innerWidth - size) / 2)
);

class HorizontalSliderTalents extends Component {
    constructor(props) {
        super(props);

        this.state = {
            indexScroll: 0,
        };

        this.maxIndexForScroll = (
            Math.round(TalentsList.length / 2) - (window.innerWidth >= Width.XL ? 3 : 2)
        );
        this.minIndexForScroll = 0;

        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }

    componentDidUpdate() {
        this.maxIndexForScroll = (
            Math.round(TalentsList.length / 2) - (window.innerWidth >= Width.XL ? 3 : 2)
        );
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        this.forceUpdate();
    }

    handleScroll(scrollDirection) {
        if (scrollDirection) {
            this.setState(({ indexScroll }) => {
                let newIndexScroll = indexScroll;
                if (scrollDirection === scrollDirections.right) {
                    if (indexScroll + 1 <= this.maxIndexForScroll) {
                        newIndexScroll += 1;
                    } else { newIndexScroll = indexScroll; }
                }
                if (scrollDirection === scrollDirections.left) {
                    if (indexScroll - 1 >= this.minIndexForScroll) {
                        newIndexScroll -= 1;
                    } else { newIndexScroll = 0; }
                }
                return { indexScroll: newIndexScroll };
            });
        }
    }


    render() {
        const { indexScroll } = this.state;
        const { className } = this.props;

        return (
            <Root className={className}>
                <ScrollWrapper
                    isShowRightButton={indexScroll < this.maxIndexForScroll}
                    isShowLeftButton={indexScroll > this.minIndexForScroll}
                >
                    <SlidesWrapper
                        indexScroll={indexScroll}
                        listLength={Math.round(TalentsList.length / 2)}
                    >
                        {TalentsList.map((talent, index) => (
                            <Slide
                                key={index.toString()}
                                isSecondRow={index >= TalentsList.length / 2}
                                listLength={Math.round(TalentsList.length / 2)}
                            >
                                <ImageWithCaption
                                    src={talent.avatar}
                                    firstName={talent.firstName}
                                    lastName={talent.lastName}
                                    profession={talent.profession}
                                />
                            </Slide>
                        ))}
                    </SlidesWrapper>
                    <ScrollButtonRight
                        isArrowRight
                        onClick={() => this.handleScroll(scrollDirections.right)}
                    />
                    <ScrollButtonLeft onClick={() => this.handleScroll(scrollDirections.left)} />
                </ScrollWrapper>
            </Root>
        );
    }
}

const Root = styled.div``;

const ScrollButtonRight = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    right: 4px;
    opacity: 1;
`;

const ScrollButtonLeft = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    left: 4px;
    opacity: 1;
`;

const ScrollWrapper = styled.div`
    width: 100%;
    overflow-y: hidden;
    overflow-x: scroll;
    scroll-behavior: smooth;

    scrollbar-width: none;
    &::-webkit-scrollbar { width: 0; }
    
    ${ScrollButtonRight} { display: none; }
    ${ScrollButtonLeft} { display: none; }
    
    ${mediaWidth.l} {
        position: relative;
        overflow-x: hidden;
        
        min-height: calc((129px * 2) + 48px);
        
        ${ScrollButtonRight} { display: ${({ isShowRightButton }) => (isShowRightButton ? 'block' : 'none')}; }
        ${ScrollButtonLeft} { display: ${({ isShowLeftButton }) => (isShowLeftButton ? 'block' : 'none')}; }
        
        :hover {
            ${ScrollButtonRight} { opacity: 1; }
            ${ScrollButtonLeft} { opacity: 1; }
        }
    }
    
    ${mediaWidth.xl} { min-height: calc((185px * 2) + 64px); }
`;

const SlidesWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    
    position: relative;
    
    width: ${({ listLength }) => (listLength) * (SlideWidthMobile + SlideMobileMarginRight) + (getOffsetLeftWidth(360, 25) || 16)}px;
    
    ${mediaWidth.m} {
      width: ${({ listLength }) => (listLength) * (SlideWidthTablet + SlideTabletMarginRight) + (getOffsetLeftWidth(768, 70) || 48)}px;
    }
    
    ${mediaWidth.l} {
      width: ${({ listLength }) => (listLength) * (SlideWidthDesktop + SlideDesktopMarginRight)}px;
      min-height: calc((129px * 2) + 48px);
      
      position: absolute;
      left: -${({ indexScroll }) => indexScroll * (SlideWidthDesktop + SlideDesktopMarginRight)}px;
      transition: left .5s ease;
      top: 0;
    }
    
    ${mediaWidth.xl} {
      width: ${({ listLength }) => (listLength) * (SlideWidthXDesktop + SlideXDesktopMarginRight)}px;
      left: -${({ indexScroll }) => indexScroll * (SlideWidthXDesktop + SlideXDesktopMarginRight)}px;
      min-height: calc((185px * 2) + 64px);
    }
`;

const Slide = styled.div`
    margin-right: ${SlideMobileMarginRight}px;
    margin-bottom: ${({ isSecondRow }) => (isSecondRow ? 0 : 32)}px;
    
    min-width: ${SlideWidthMobile}px;
    width: ${SlideWidthMobile}px;
    height: 128px;
    
    ${({ listLength }) => (`
        &:nth-child(1) {margin-left: ${getOffsetLeftWidth(360) || 16}px;}
        &:nth-child(${listLength + 1}) {margin-left: ${getOffsetLeftWidth(360) || 16}px;}
    `)}
    
    ${mediaWidth.m} {
        margin-right: ${SlideTabletMarginRight}px;
        margin-bottom: ${({ isSecondRow }) => (isSecondRow ? 0 : 48)}px;
        
        min-width: ${SlideWidthTablet}px;
        width: ${SlideWidthTablet}px;
        height: 128px;
        
        ${({ listLength }) => (`
            &:nth-child(1) {margin-left: ${getOffsetLeftWidth(768, 32) || 48}px;}
            &:nth-child(${listLength + 1}) {margin-left: ${getOffsetLeftWidth(768, 32) || 48}px;}
        `)}
    }
    
    ${mediaWidth.l} {
        margin-right: ${SlideDesktopMarginRight}px;
        margin-bottom: ${({ isSecondRow }) => (isSecondRow ? 0 : 48)}px;

        min-width: ${SlideWidthDesktop}px;
        width: ${SlideWidthDesktop}px;
        height: 129px;
        
        &:nth-child(1) {margin-left: 0;}
        &:nth-child(${({ listLength }) => listLength + 1}) {margin-left: 0;}
    }
    
    ${mediaWidth.xl} {
        margin-right: ${SlideXDesktopMarginRight}px;
        margin-bottom: ${({ isSecondRow }) => (isSecondRow ? 0 : 57)}px;
        
        min-width: ${SlideWidthXDesktop}px;
        width: ${SlideWidthXDesktop}px;
        height: 185px;
    }
`;

export default HorizontalSliderTalents;
